import '@abtasty/design-system/dist/assets/static/reset.css';
import '@abtasty/design-system/dist/assets/static/fonts.css';
import '@abtasty/design-system/dist/commonui.css';

import { createElement } from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './modules/App';
import * as Sentry from '@sentry/browser';
import { DISABLED_COOKIES, SENTRY_TAG_ERROR_BOUNDARY } from './modules/tag/shared/constants';

Sentry.init({
  dsn: 'https://5eed0dc297f74158b2ce9333b9e62211@o132438.ingest.sentry.io/5608642',
  integrations: [],
  environment: process.env.ENV,
  enabled: process.env.ENV === 'production',
  tracesSampleRate: 1,
  ignoreErrors: [DISABLED_COOKIES, 'Non-Error exception captured', 'Non-Error promise rejection captured'],
  beforeSend(event) {
    if (event.tags && event.tags[SENTRY_TAG_ERROR_BOUNDARY] && event.exception && event.exception.values) {
      // For error caught in error boundary, override `mechanism.handled` to record that as a crash
      event.exception.values.forEach((value) => {
        if (value.mechanism) {
          value.mechanism.handled = false;
        }
      });
    }
    return event;
  },
  denyUrls: [
    // AB Tasty tag
    /(.+)try\.abtasty\.com\/(.+)\.js/i,
    // AB Tasty Widgets
    /(.+)widgets.abtasty\.com\/+@([a-z]+)\//i,
    // Clarity
    /clarity\.ms/i,
    // Google Tag Manager
    /googletagmanager\.com\/gtm\.js/i,
    // AB Tasty Session recording
    /sr-tag\.abtasty\.com\/abtasty\.js/i,
    // Segment
    /cdn\.segment\.com\/analytics\.js/i,
    // Mixpanel - used in Segment
    /.+cdn\.mxpnl\.com/i,
    // usejimo - used in Segment for APP2
    /.+\.usejimo\.com/i,
    // Intercom
    /js\.intercomcdn\.com/i,
    // Chrome extensions
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^chrome:\/\//i,
    // Others
    /127\.0\.0\.1:/i,
    /localhost:/i,
  ],
});

const domContainer = document.getElementById('app');

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(createElement(App), domContainer);

if (module.hot) {
  module.hot.accept(() => {});
}
